import { Accordion, AccordionSummary, AccordionDetails, Typography, Skeleton } from '@mui/material';
import { Stack } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import { FC, Suspense } from 'react';
import { useToggle } from '../../../../../../../../../../../hooks/use-toggle';
import { ErpProductSettingsAccordionContent } from './erp-product-settings-accordion-components/ErpProductSettingsAccordionContent';

type ErpProductSettingsAccordionProps = {
  invoiceId: string;
  customerId: string;
  disabled: boolean;
};

export const ErpProductSettingsAccordion: FC<ErpProductSettingsAccordionProps> = ({
  invoiceId,
  customerId,
  disabled,
}) => {
  const [expanded, toggleExpanded] = useToggle(true);

  return (
    <Accordion expanded={expanded} onChange={() => toggleExpanded()} sx={{ p: 0 }}>
      <AccordionSummary
        expandIcon={
          <VyIcon
            icon="ArrowDown"
            style={{
              color: '#323232',
            }}
          />
        }
        sx={{ p: 0, height: '34px', alignItems: 'center' }}
      >
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            gap: 1
          }}>
          <VyIcon icon="OverdueClockStatus" />
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 600,
              lineHeight: "24px"
            }}>
            Products classification
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <Suspense fallback={<Skeleton variant="rectangular" height={100} />}>
          <ErpProductSettingsAccordionContent invoiceId={invoiceId} customerId={customerId} disabled={disabled} />
        </Suspense>
      </AccordionDetails>
    </Accordion>
  );
};
